var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 202,
    viewBox: "0 0 330 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_2540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.913 70.216C190.913 70.216 231.198 87.5606 226.223 128.403C221.249 169.245 186.623 165.14 186.623 165.14L190.913 70.216Z",
    fill: "#3F7CDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M190.913 70.216C190.913 70.216 231.198 87.5606 226.223 128.403C221.249 169.245 186.623 165.14 186.623 165.14L190.913 70.216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.569 48.651C165.569 48.651 166.13 53.1936 165.47 56.2496C165.405 56.5452 165.282 56.825 165.108 57.073C164.935 57.3211 164.714 57.5324 164.459 57.6951C164.204 57.8577 163.919 57.9683 163.621 58.0208C163.323 58.0732 163.018 58.0663 162.723 58.0005C161.754 57.8521 160.849 57.4261 160.117 56.7739C159.385 56.1216 158.858 55.2711 158.598 54.3251L157.088 50.3772C156.874 49.5565 156.918 48.6898 157.213 47.8948C157.508 47.0998 158.041 46.4151 158.738 45.9337C161.287 43.9845 165.371 45.8676 165.569 48.651Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.245 52.7311L157.006 67.7217L165.264 67.2592L162.121 56.5386L157.245 52.7311Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.659 53.9452C156.663 54.0419 156.699 54.1344 156.762 54.2079C156.825 54.2813 156.911 54.3314 157.006 54.3499C157.649 54.5087 158.327 54.4516 158.935 54.1875C159.543 53.9235 160.048 53.4669 160.372 52.888C160.759 52.2536 160.952 51.5191 160.925 50.7761C160.899 50.033 160.655 49.3141 160.223 48.7088C161.62 48.9268 163.037 48.985 164.447 48.8822C164.921 48.8468 165.386 48.7353 165.825 48.5519L166.881 45.0747C166.881 45.0747 168.638 41.581 166.592 40.945C164.546 40.3091 163.672 42.5969 161.989 40.945C160.306 39.2932 159.91 38.7233 158.243 39.6731C156.577 40.6229 158.532 41.9196 155.768 41.9857C153.005 42.0518 152.963 43.1916 152.98 44.4635C153.045 44.8948 153.24 45.2957 153.541 45.6116C155.455 47.9774 156.55 50.9023 156.659 53.9452V53.9452Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.775 51.5252L167.104 53.2514C167.179 53.3487 167.228 53.4633 167.248 53.5847C167.267 53.7061 167.256 53.8304 167.215 53.9463C167.173 54.0621 167.104 54.1658 167.013 54.2479C166.921 54.3299 166.811 54.3877 166.691 54.416L164.959 54.8042L165.775 51.5252Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M162.525 57.9758C162.525 57.9758 161.461 58.0418 159.225 56.8112C159.225 56.8112 159.646 59.7763 163.466 61.1226L162.525 57.9758Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.149 69.2662C141.149 69.2662 194.931 58.9669 203.024 81.0688C210.449 101.288 195.377 151.909 195.377 151.909L148.302 155.064C148.302 155.064 96.9293 81.713 141.149 69.2662Z",
    fill: "#3F7CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.377 151.909L202.521 168.312L142.989 167.8L148.302 155.064L195.377 151.909Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M147.386 80.1685C147.386 80.1685 161.964 86.33 155.636 106.838C149.309 127.346 148.649 139.759 159.225 135.456C159.225 135.456 175.428 112.661 179.165 97.5957L180.436 90.9882L197.373 94.6388L190.295 126.024L179.413 125.52L170.585 153.511L148.31 155.006L129.591 135.646L132.124 115.7L147.386 80.1685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2 77.9468C143.678 76.7949 141.941 75.9603 140.091 75.4923C138.241 75.0242 136.316 74.9323 134.43 75.2218C132.544 75.5113 130.736 76.1765 129.111 77.1779C127.486 78.1794 126.078 79.4968 124.971 81.0523C118.124 90.5505 110.294 109.44 121.349 140.016C133.601 173.879 158.474 158.07 172.499 120.936L167.945 116.807C167.945 116.807 148.5 147.664 141.149 133.012C134.912 120.647 160.388 89.8402 145.2 77.9468Z",
    fill: "#3F7CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.649 87.4987L168.57 82.2516L161.785 113.46L185.864 118.707L192.649 87.4987Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M145.2 77.9468C143.678 76.7949 141.941 75.9603 140.091 75.4923C138.241 75.0242 136.316 74.9323 134.43 75.2218C132.544 75.5113 130.736 76.1765 129.111 77.1779C127.486 78.1794 126.078 79.4968 124.971 81.0523C118.124 90.5505 110.294 109.44 121.349 140.016C133.601 173.879 158.474 158.07 172.499 120.936L167.945 116.807C167.945 116.807 148.5 147.664 141.149 133.012C134.912 120.647 160.388 89.8402 145.2 77.9468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.928 82.9719L177.141 81.2749L175.962 86.6982L183.749 88.3951L184.928 82.9719Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.635 168.312L161.254 143.534H192.299L194.989 164.653L209.22 164.851V168.312H165.635Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.676 146.4L191.796 164.323H168.688L165.982 146.4H189.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.956 161.135H128.593V167.453H156.956V161.135Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.956 154.849H128.593V161.168H156.956V154.849Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M156.956 154.849H128.593V161.168H156.956V154.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.523 118.004C116.523 118.004 133.106 130.451 140.192 147.944C141.079 150.105 141.423 152.45 141.193 154.774C140.964 157.099 140.169 159.331 138.877 161.276C137.586 163.222 135.838 164.82 133.786 165.931C131.734 167.043 129.441 167.633 127.108 167.651L107.663 167.783L116.523 118.004Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35 36.452C138.278 36.452 144.705 31.0975 144.705 24.4925C144.705 17.8874 138.278 12.533 130.35 12.533C122.422 12.533 115.995 17.8874 115.995 24.4925C115.995 31.0975 122.422 36.452 130.35 36.452Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.365 29.9519L145.472 38.649L137.057 32.4049L140.365 29.9519Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.01 26.2682C136.989 26.2682 137.783 25.4732 137.783 24.4925C137.783 23.5118 136.989 22.7167 136.01 22.7167C135.03 22.7167 134.236 23.5118 134.236 24.4925C134.236 25.4732 135.03 26.2682 136.01 26.2682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.317 26.2682C131.297 26.2682 132.091 25.4732 132.091 24.4925C132.091 23.5118 131.297 22.7167 130.317 22.7167C129.337 22.7167 128.543 23.5118 128.543 24.4925C128.543 25.4732 129.337 26.2682 130.317 26.2682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.699 26.2682C125.678 26.2682 126.473 25.4732 126.473 24.4925C126.473 23.5118 125.678 22.7167 124.699 22.7167C123.719 22.7167 122.925 23.5118 122.925 24.4925C122.925 25.4732 123.719 26.2682 124.699 26.2682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 52.4255C165 52.4255 164.909 50.6745 163.589 50.8562C162.269 51.0379 162.401 53.5735 164.2 53.7552L165 52.4255Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.32 167.461H65.4226V178.116H270.32V167.461Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.32 177.62H65.4226V201.77H270.32V177.62Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M188.1 167.783C188.1 167.783 181.228 193.09 165 201.77H270.311L268.208 187.878L199.468 167.461L188.1 167.783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.161 101.197L234.663 109.902L242.492 110.472L237.724 96.555L233.161 101.197Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.9 88.3452C235.219 87.8117 234.416 87.4565 233.564 87.3116C232.711 87.1668 231.836 87.2369 231.017 87.5156C230.198 87.7943 229.462 88.2728 228.874 88.908C228.286 89.5431 227.866 90.3148 227.65 91.1534C226.586 95.1427 225.86 100.974 230.48 101.445C237.55 102.18 238.78 93.0531 238.78 93.0531C238.308 91.2326 237.305 89.5939 235.9 88.3452V88.3452Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.539 94.9114C234.539 94.9114 235.273 93.0861 236.717 94.3415C238.161 95.5969 236.23 97.6452 235.108 97.1992C233.986 96.7532 234.539 94.9114 234.539 94.9114Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.782 93.3917C232.782 93.3917 234.259 102.766 238.796 99.6853C243.334 96.6046 238.887 94.6306 239.382 89.8402C239.877 85.0498 237.353 83.3484 232.064 82.2168C229.639 81.7048 228.162 81.6469 227.114 81.2588C226.653 81.0755 226.153 81.0126 225.661 81.0758C225.169 81.1391 224.701 81.3265 224.301 81.6204C223.901 81.9143 223.582 82.3051 223.374 82.7561C223.167 83.2072 223.077 83.7037 223.113 84.1991C223.476 87.891 225.646 91.9546 232.782 93.3917Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.307 114.684C263.307 114.684 244.464 104.211 227.692 110.472C197.167 121.87 198.94 143.063 220.382 201.77L247.813 201.613L263.307 114.684Z",
    fill: "#3F7CDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M234.391 109.192C234.391 109.192 236.206 113.66 233.079 126.66C229.952 139.66 213.791 183.228 213.791 183.228L220.201 201.457H230.423L261.863 114.37C261.863 114.37 247.649 107.011 234.391 109.192Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7 201.77C227.7 201.77 222.288 120.887 256.575 114.684C290.862 108.481 302.165 137.951 282.15 201.217L227.7 201.77Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.42 201.217C236.42 201.217 230.645 120.887 264.891 114.684C299.137 108.481 309.697 138.909 289.682 202.175L236.42 201.217Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M236.47 201.68C236.47 201.68 230.637 120.887 264.891 114.684C299.145 108.481 309.697 138.909 289.682 202.175L236.47 201.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.455 130.889C229.878 119.863 215.886 115.403 209.005 124.001C203.659 130.649 199.93 140.437 200.392 154.874C201.217 184.541 181.566 201.795 181.566 201.795H201.539C201.539 201.795 218.509 181.725 227.725 150.026C230.01 142.014 230.711 135.754 230.455 130.889Z",
    fill: "#3F7CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2346 101.197L95.7248 109.902L87.9038 110.472L92.6641 96.555L97.2346 101.197Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4955 88.3452C95.1766 87.8117 95.9797 87.4565 96.8324 87.3116C97.685 87.1668 98.5603 87.2369 99.3791 87.5156C100.198 87.7943 100.934 88.2728 101.522 88.908C102.11 89.5431 102.53 90.3148 102.745 91.1534C103.801 95.1427 104.527 100.974 99.9157 101.445C92.8455 102.18 91.6162 93.0531 91.6162 93.0531C92.0883 91.2326 93.0906 89.5939 94.4955 88.3452V88.3452Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8568 94.9114C95.8568 94.9114 95.1225 93.0861 93.6705 94.3415C92.2185 95.5969 94.1573 97.6452 95.3205 97.1992C96.4838 96.7532 95.8568 94.9114 95.8568 94.9114Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0891 114.684C67.0891 114.684 85.9321 104.211 102.704 110.472C133.229 121.87 131.579 142.353 110.129 201.06L82.0216 201.217L67.0891 114.684Z",
    fill: "#3F7CDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M95.9228 108.795C95.9228 108.795 94.1078 113.264 97.2346 126.264C100.361 139.264 116.523 182.824 116.523 182.824L110.113 201.093H99.8911L68.4751 113.99C68.4751 113.99 82.6651 106.615 95.9228 108.795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3 201.217C102.3 201.217 108.075 120.887 73.8292 114.684C39.5834 108.481 28.2314 137.951 48.2459 201.217H102.3Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9757 201.217C93.9757 201.217 99.7507 120.887 65.5049 114.684C31.2592 108.481 19.8659 137.951 39.8887 201.217H93.9757Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M93.9757 201.217C93.9757 201.217 99.7507 120.887 65.5049 114.684C31.2592 108.481 19.8659 137.951 39.8887 201.217H93.9757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1301 105.392C87.268 103.914 88.0268 102.179 88.3403 100.339C88.6538 98.4986 88.5125 96.6098 87.9286 94.8371C87.1036 92.1198 87.1036 88.6343 90.2056 84.9755C97.0366 76.8731 106.796 82.5885 103.562 87.2055C100.328 91.8224 98.5546 93.8955 98.5546 93.8955C98.5546 93.8955 110.344 106.284 104.198 113.875C98.7361 120.598 76.3951 117.765 86.1301 105.392Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.077 117.426C173.077 117.426 174.57 112.165 178.027 110.472C181.483 108.779 182.449 116.964 176.632 120.598L173.077 117.426Z",
    fill: "#F4A28C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_2540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 202,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIllustration);
export default __webpack_public_path__ + "static/media/team-illustration.620a4134e47abf77e2d7a21103ab6230.svg";
export { ForwardRef as ReactComponent };